// High-order components must use the spreading operator
// to pass the props down to the real one.
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { getToken } from '../api/token';
import { isJsonString } from '../../utils/jsonParsing';
import { ToastError } from '../../ui/components/Toast';

export function withMultiFileUploader(LazyComp) {
  const WithFileUploader = (props) => {
    // eslint-disable-next-line no-unused-vars
    const [progress, setProgress] = useState({});

    function createFormData(files, keys) {
      if (!files) return;

      const formData = new FormData();

      keys.forEach((key) => {
        const file = files[key];
        let formFile = null;
        if (typeof File === 'function') {
          formFile = new File([file?.file || file], file?.name || file);
        } else {
          // IE11
          formFile = new Blob([file?.file || file]);
        }

        formData.append(key, formFile);
      });

      // eslint-disable-next-line consistent-return
      return formData;
    }

    const onFileLoad = (
      keys,
      files,
      url,
      onFileUpload = () => {},
      closeLoader = () => {},
      onError = () => {}
    ) => {
      if (!(files && Object.values(files).length === keys?.length)) return;

      const { token } = getToken();

      const formData = createFormData(files, keys);
      if (!formData) return;

      const fileUpload = new XMLHttpRequest();

      fileUpload.addEventListener(
        'load',
        (progressLoad) => {
          if (onFileUpload) {
            closeLoader();
            const { target: { response: rawResponse = {} } = {} } =
              progressLoad;

            if (isJsonString(rawResponse)) {
              const data = JSON.parse(rawResponse);
              if (data?.code !== 200) {
                onError();
                toast.error(
                  <ToastError
                    title="Qualcosa è andato storto"
                    body="Riprova più tardi"
                  />
                );
              }
              onFileUpload();
            } else {
              onError();
              toast.error(
                <ToastError
                  title="Qualcosa è andato storto"
                  body="Riprova più tardi"
                />
              );
              onFileUpload();
            }
          }
        },
        false
      );

      fileUpload.addEventListener(
        'error',
        (error) => {
          onError();
          // eslint-disable-next-line no-console
          console.log('fileUploadCall error', error);
          closeLoader();
        },
        false
      );

      fileUpload.addEventListener(
        'abort',
        (abortHandler) => {
          // eslint-disable-next-line no-console
          console.log('abort', abortHandler);
          closeLoader();
        },
        false
      );

      fileUpload.open('POST', url);
      fileUpload.setRequestHeader('Authorization', `Bearer ${token}`);
      fileUpload.send(formData);
    };

    return (
      <LazyComp {...props} onFileLoad={onFileLoad} uploadProgress={progress} />
    );
  };

  WithFileUploader.propTypes = {
    onFileUpload: PropTypes.func,
  };

  WithFileUploader.displayName = `WithFileUploader(${
    LazyComp?.displayName || LazyComp?.name || 'Component'
  })`;

  return WithFileUploader;
}
